import React from 'react'
import styled from 'styled-components'
import { Flex, TooltipText, IconButton, CalculateIcon, useTooltip, Text } from 'vvs-uikit'
import { useTranslation } from 'contexts/Localization'
import Balance from 'components/Balance'

const ApyLabelContainer = styled(Flex)`
  cursor: pointer;

  &:hover {
    opacity: 0.5;
  }
`

interface AprRowProps {
  text: string
  onCalculatorClick: () => void
  small?: boolean
  disableTooltip?: boolean
  apr: number
}

const AprRow = ({ text, small, disableTooltip, onCalculatorClick, apr }: AprRowProps) => {
  const { t } = useTranslation()

  const tooltipContent = t(
    'Returns are automatically compounded, so when you return your xVVS, you will receive more VVS than when you initially deposited.',
  )
  const { targetRef, tooltip, tooltipVisible } = useTooltip(tooltipContent, { placement: 'bottom-start' })

  const renderTooltipContent = () => (
    <>
      {tooltipVisible && tooltip}
      <TooltipText color="textSubtle" small ref={targetRef}>
        {text}
      </TooltipText>
    </>
  )

  const renderPlainTextContent = () => (
    <Text color="textSubtle" small ref={targetRef}>
      {text}
    </Text>
  )

  return (
    <Flex alignItems="center" justifyContent="space-between">
      {disableTooltip ? renderPlainTextContent() : renderTooltipContent()}
      <ApyLabelContainer alignItems="center" onClick={onCalculatorClick}>
        <Balance fontSize={small ? '16px' : '24px'} bold color="text" value={apr} decimals={2} unit="%" />
        <IconButton variant="text" scale="sm">
          <CalculateIcon color="textSubtle" width="24px" />
        </IconButton>
      </ApyLabelContainer>
    </Flex>
  )
}

export default AprRow
